export default __webpack_public_path__ + "static/media/partner-call.695b40c0.mp3";